module.exports = __webpack_public_path__ + "static/media/news-icon.9ac3c68c.svg";